/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flag_MessageInputs */

const en_flag_message = /** @type {(inputs: Flag_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flag Message`)
};

const id_flag_message = /** @type {(inputs: Flag_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tandai Pesan`)
};

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const es_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const fr_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const de_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const ja_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const zh_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const ar_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const it_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const ru_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const pt_flag_message = en_flag_message;

/** @type {(inputs: Flag_MessageInputs) => LocalizedString} */
const ko_flag_message = en_flag_message;

/**
* | output |
* | --- |
* | "Flag Message" |
*
* @param {Flag_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const flag_message = /** @type {((inputs?: Flag_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flag_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flag_message(inputs)
	if (locale === "es") return es_flag_message(inputs)
	if (locale === "fr") return fr_flag_message(inputs)
	if (locale === "de") return de_flag_message(inputs)
	if (locale === "ja") return ja_flag_message(inputs)
	if (locale === "zh") return zh_flag_message(inputs)
	if (locale === "ar") return ar_flag_message(inputs)
	if (locale === "id") return id_flag_message(inputs)
	if (locale === "it") return it_flag_message(inputs)
	if (locale === "ru") return ru_flag_message(inputs)
	if (locale === "pt") return pt_flag_message(inputs)
	return ko_flag_message(inputs)
});